var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCCollaborator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#FEFAF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "#F7B27A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3599 33.0866H51.3912C51.1639 31.7798 50.7449 30.6222 50.1341 29.6136C49.5233 28.5909 48.7633 27.7244 47.8542 27.0142C46.9451 26.304 45.9082 25.7713 44.7434 25.4162C43.5929 25.0469 42.35 24.8622 41.0147 24.8622C38.6426 24.8622 36.5403 25.4588 34.7079 26.652C32.8755 27.831 31.4409 29.5639 30.4039 31.8509C29.367 34.1236 28.8485 36.9006 28.8485 40.1818C28.8485 43.5199 29.367 46.3324 30.4039 48.6193C31.4551 50.892 32.8897 52.6108 34.7079 53.7756C36.5403 54.9261 38.6355 55.5014 40.9934 55.5014C42.3002 55.5014 43.5218 55.331 44.6582 54.9901C45.8088 54.6349 46.8386 54.1165 47.7477 53.4347C48.671 52.7528 49.4451 51.9148 50.0701 50.9205C50.7093 49.9261 51.1497 48.7898 51.3912 47.5114L59.3599 47.554C59.0616 49.6278 58.4153 51.5739 57.421 53.392C56.4409 55.2102 55.1554 56.8153 53.5645 58.2074C51.9735 59.5852 50.1128 60.6648 47.9821 61.446C45.8514 62.2131 43.4863 62.5966 40.8869 62.5966C37.0517 62.5966 33.6284 61.7088 30.617 59.9332C27.6056 58.1577 25.2335 55.5938 23.5005 52.2415C21.7676 48.8892 20.9011 44.8693 20.9011 40.1818C20.9011 35.4801 21.7747 31.4602 23.5218 28.1222C25.269 24.7699 27.6483 22.206 30.6596 20.4304C33.671 18.6548 37.0801 17.767 40.8869 17.767C43.3159 17.767 45.5744 18.108 47.6625 18.7898C49.7505 19.4716 51.6113 20.473 53.2449 21.794C54.8784 23.1009 56.2207 24.706 57.2718 26.6094C58.3372 28.4986 59.0332 30.6577 59.3599 33.0866Z",
    fill: "#EF6820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCCollaborator);
export default __webpack_public_path__ + "static/media/c-collaborator.11a0e615140d16f4e969eef6c93aaa91.svg";
export { ForwardRef as ReactComponent };